export default __webpack_public_path__ + "static/media/facebook-icon.08e15f68.svg";